import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedUiModule } from '@digital-platform/shared/ui';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import {
  PasswordRequirements,
  PASSWORD_REQUIREMENTS as PASSWORD_REQUIREMENTS_CONST,
} from '@digital-platform/users/domain';
import { UsersServicesModule } from '@digital-platform/users/services';
import { AddExistingGeneratorFormComponent } from './add-existing-generator-form/add-existing-generator-form.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { inviteCodeFormatDirective } from './create-account/invite-code.directive';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordSubmittedComponent } from './forgot-password-submitted/forgot-password-submitted.component';
import { InviteUserFormComponent } from './invite-user-form/invite-user-form.component';
import { LoginComponent } from './login/login.component';
import { OnboardingDialogComponent } from './onboarding-dialog/onboarding-dialog.component';
import { OnboardingWasteProfileEntryComponent } from './onboarding-waste-profile-entry/onboarding-waste-profile-entry.component';
import { PasswordFeedbackComponent } from './password-feedback/password-feedback.component';
import { PermissionDirective } from './permission/permission.directive';
import { ProfileInformationFormComponent } from './profile-information-form/profile-information-form.component';

export const PASSWORD_REQUIREMENTS = new InjectionToken<PasswordRequirements>(
  'password.requirements'
);

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedUiMaterialModule,
    UsersServicesModule,
    SharedUiModule,
    RouterModule.forChild([]),
  ],
  exports: [
    LoginComponent,
    ForgotPasswordComponent,
    ProfileInformationFormComponent,
    PermissionDirective,
    ChangePasswordComponent,
    CreateAccountComponent,
    OnboardingDialogComponent,
    OnboardingWasteProfileEntryComponent,
    AddExistingGeneratorFormComponent,
    InviteUserFormComponent,
  ],
  declarations: [
    inviteCodeFormatDirective,
    LoginComponent,
    ForgotPasswordComponent,
    ProfileInformationFormComponent,
    ForgotPasswordSubmittedComponent,
    PermissionDirective,
    ChangePasswordComponent,
    CreateAccountComponent,
    OnboardingDialogComponent,
    OnboardingWasteProfileEntryComponent,
    AddExistingGeneratorFormComponent,
    PasswordFeedbackComponent,
    InviteUserFormComponent,
  ],
  providers: [
    { provide: PASSWORD_REQUIREMENTS, useValue: PASSWORD_REQUIREMENTS_CONST },
  ],
})
export class UsersUiModule {}
